import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import parse from "html-react-parser";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
function Header() {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    let partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const partnerEmail: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.email ? state.configurationState.configuration.partnerConfig.email : ""
    );
    const partnerId: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : ""
    );
    const retailerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            ? state.configurationState.configuration.partnerConfig.retailerPhoneNumber
            : ""
    );
    const IsIDFTemplate: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isIDFTemplate
            ? state.configurationState.configuration.partnerConfig.isIDFTemplate
            : false
    );
    const promoBannerText: string = useSelector((state: ApplicationState) =>
        state.testimonialsState && state.testimonialsState.promoBannerText ? state.testimonialsState.promoBannerText : ""
    );
    const location = useLocation();
    const pageURL = window.location.origin;
    let url = window.location.href;
    const query = new URLSearchParams(location.search);
    const RetailerCode: any = query.get('RetailerCode') || query.get('RETAILERCODE');
    const OfferCode = query.get("offerCode");
    if (retailerPhoneNumber.trim() != "") {
        partnerPhoneNumber = retailerPhoneNumber;
    }

    const brandingOptions = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath) {
            return {
                imagePath: state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath,
                secondaryLogo: state.configurationState.configuration?.partnerConfig?.brandingOption?.secondaryLogo,
                associationText: state.configurationState.configuration?.partnerConfig?.brandingOption?.associationText,
                secondaryText: state.configurationState.configuration?.partnerConfig?.brandingOption?.secondaryText,
                originalSiteUrl: state.configurationState.configuration?.partnerConfig?.originSiteUrl,
                externalImagePath:state.configurationState.configuration?.partnerConfig?.brandingOption?.externalImagePath,

            };
        } else {
            return {
                imagePath: "",
                associationText: "",
                secondaryText: "",
                originalSiteUrl: "",
            };
        }
    });

    const routeToLogoPage = () => {
        window.addToDataLayer({ event: "dtcLogoClick" });
        let logoPath = pageURL+"/app/sales_landing/step2?RetailerCode=" + RetailerCode + (OfferCode != null ? "&offerCode=" + OfferCode : "");
        window.location.href = logoPath;
    };

    const routeToLoginPage = () => {
        window.addToDataLayer({ event: "dtcBtnLogin" });
        let loginPath = pageURL + "/app/login";
        window.location.href = loginPath;
    };
    useEffect(() => {
        sessionStorage.setItem("header", "header-div");
    }, []);

    const skipToMainContent = () => {
        const mainContent = sessionStorage.getItem("mainContent");
        if (typeof mainContent === "string") {
            const targetElement = document.getElementById(mainContent);
            if (targetElement) {
                targetElement.focus();
            }
        }
    };
    const hideChangePlan: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hideChangePlan
    );
    const logoClass = brandingOptions?.associationText.length > 0 ? "right-border" : "";
    const getLoginSectionByPartnerFn = () => {
        return !IsIDFTemplate ? (
            <div className="col-md-5 d-none d-md-block header_phone_link login-section-variation2">
                <p role="navigation">
                    <button
                        className="btn-default btn-primary secure-login"
                        tabIndex={0}
                        onClick={routeToLoginPage}
                        type="button"
                        style={{ padding: "2px 10px 2px 10px" }}
                    >
                        <span className="btn-text">SECURE LOGIN</span>
                    </button>
                </p>
                <p id="phone-button-wrapper" className="phone-link-wrapper">
                    <a href={"tel:" + partnerPhoneNumber.replace(new RegExp("-", "g"), "")} tabIndex={0} id="phone-button" className="dial-link">
                        <span style={{ color: "black" }}>INTL : </span>
                        <span className="dial-link-phoneNumber">{partnerPhoneNumber}</span>
                    </a>
                </p>
            </div>
        ) : (
            <div className="d-none d-md-block header_phone_link login-section-variation1">
                <p role="navigation">
                    <a className="btn-default secure-login" href="javascript:void(0)" tabIndex={0} onClick={routeToLoginPage}>
                        SECURE LOGIN
                    </a>
                </p>
                <p id="phone-button-wrapper">
                    <a
                        href={"tel:" + partnerPhoneNumber.replace(new RegExp("-", "g"), "")}
                        onClick={() => {
                            window.addToDataLayer({ event: "dtcClickToCallTFN" });
                        }}
                        tabIndex={0}
                        id="phone-button"
                        className="dial-link dial-link1"
                    >
                        <span>{partnerPhoneNumber}</span>
                    </a>
                </p>

            </div>
        );
    };

    return (
        <>
            <header style={{ borderBottom: "3px solid #D9D9D9" }}>
                {(promoBannerText.length > 0  && url.toLowerCase().includes("/step2?")) ?
                    <div className="banner-text-div">
                        {promoBannerText.includes("\n") ?
                            promoBannerText.split("\n").map((promoText, index) => { return  index < 2 ? <p className="banner-text"><strong>{promoText}</strong></p> : "" })
                            :
                            <p className="banner-text no-lines"><strong>{promoBannerText}</strong></p>
                        }
                    </div> : ""
                }
                <div className="container header" id="header-div" tabIndex={-1} >
                    <button id="skip-main-btn" className="skip-main
                    " onClick={() => skipToMainContent()}>
                        {tLang("skipToMainContent.label")}
                    </button>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12">
                            <div className="row" style={{ minHeight: "87px" }}>
                                <div className="col-xs-12 col-md-7">
                                    <div className="logo-and-tagline">
                                        <div>
                                            {!(hideChangePlan) ?
                                                <a
                                                    href="javascript:void(0)"
                                                    onClick={routeToLogoPage}
                                                    tabIndex={0}
                                                    className={logoClass}
                                                    title="Go to Homepage"
                                                >
                                                    <img src={brandingOptions?.externalImagePath ? brandingOptions.externalImagePath : brandingOptions?.imagePath} alt="Sontiq Logo" />
                                                </a>
                                                :
                                                <span className={logoClass}>
                                                    <img src={brandingOptions?.externalImagePath ? brandingOptions.externalImagePath : brandingOptions?.imagePath} alt="Sontiq Logo" />
                                                </span>
                                            }
                                            {brandingOptions != null && brandingOptions.secondaryLogo != null && brandingOptions.secondaryLogo.length > 0 && (
                                                !(hideChangePlan) ?
                                                    <a
                                                        href="javascript:void(0)"
                                                        onClick={routeToLogoPage}
                                                        tabIndex={0}
                                                        className={logoClass}
                                                        title="Go to Homepage"
                                                    >
                                                        <img src={brandingOptions?.secondaryLogo} alt="Sontiq Logo" />
                                                    </a>
                                                    :
                                                    <span className={logoClass}>
                                                        <img src={brandingOptions?.secondaryLogo} alt="Sontiq Logo" />
                                                    </span>
                                            )}
                                            {IsIDFTemplate && (
                                                <p id="header-tagline-text" className="header-tagline">
                                                    Protect What Matters Most.<sup>TM</sup>
                                                </p>
                                            )}
                                            <div className="logo-secondary-container">
                                                <div>{brandingOptions?.associationText}</div>
                                                <div>{parse(brandingOptions?.secondaryText || "", {})}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {getLoginSectionByPartnerFn()}
                            </div>
                        </div>
                    </div>

                    <div className="row contact-us">
                        <div className="col-12">
                            <div className="col-4">
                                <em className="fa fa-phone"></em>
                                <a href={"tel:" + partnerPhoneNumber.replace(new RegExp("-", "g"), "")}>
                                    <span id="phonenumber-mobile" className="phonenumber phone-button">
                                        {partnerPhoneNumber}
                                    </span>
                                </a>
                            </div>
                            <div className="col-5">
                                <a href={"mailto:" + partnerEmail}>
                                    <em className="fa fa-envelope"></em> Send An Email
                                </a>
                            </div>
                            <div className="col-3">
                                <a className="hover-pointer" onClick={routeToLoginPage} href="javascript:void(0)">
                                    <em className="fa fa-user"></em> Login
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div className="header-spacer"></div>
        </>
    );
}

export default Header;
